import React from 'react';
import { Star } from 'lucide-react';
import { Card } from './ui/card';

const Testimonials = () => {
  const testimonials = [
    {
      name: "Sarah Mitchell",
      role: "Marketing Professional",
      image: "https://images.unsplash.com/photo-1494790108377-be9c29b29330?w=150&h=150&fit=crop",
      rating: 5,
      text: "Ovalu has completely changed how I understand my body. The AI predictions are incredibly accurate, and I love the cycle-synced yoga recommendations. It's like having a personal health coach in my pocket!",
      highlight: "Life-changing app!"
    },
    {
      name: "Priya Sharma",
      role: "Yoga Instructor",
      image: "https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=150&h=150&fit=crop",
      rating: 5,
      text: "As a yoga instructor, I'm impressed by how accurately Ovalu recommends poses for each cycle phase. The pregnancy mode is fantastic too! I recommend it to all my students.",
      highlight: "Perfect for wellness"
    },
    {
      name: "Emma Johnson",
      role: "Software Engineer",
      image: "https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=150&h=150&fit=crop",
      rating: 5,
      text: "Finally, an app that gets it right! The AI chat assistant is so helpful, and I love that I can track everything in one place. The premium features are absolutely worth it.",
      highlight: "Best period tracker!"
    },
    {
      name: "Dr. Anjali Desai",
      role: "Gynecologist",
      image: "https://images.unsplash.com/photo-1559839734-2b71ea197ec2?w=150&h=150&fit=crop",
      rating: 5,
      text: "I recommend Ovalu to my patients. The cycle predictions are science-based, and the ability to export reports makes consultations more productive. Great tool for women's health awareness.",
      highlight: "Doctor recommended"
    },
    {
      name: "Lisa Chen",
      role: "Fitness Enthusiast",
      image: "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=150&h=150&fit=crop",
      rating: 5,
      text: "The personalized health plans are amazing! Knowing when to push hard at the gym and when to rest has improved my fitness journey. The WhatsApp reminders are super convenient.",
      highlight: "Game changer!"
    },
    {
      name: "Aisha Rahman",
      role: "New Mom",
      image: "https://images.unsplash.com/photo-1489424731084-a5d8b219a5bb?w=150&h=150&fit=crop",
      rating: 5,
      text: "The pregnancy mode is incredible! Week-by-week tracking with baby development insights kept me informed throughout my journey. Now using it again for cycle tracking postpartum.",
      highlight: "Pregnancy essential"
    }
  ];

  return (
    <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
      {testimonials.map((testimonial, index) => (
        <Card key={index} className="p-6 border-pink-100 hover:shadow-xl transition-all duration-300">
          {/* Rating */}
          <div className="flex items-center gap-1 mb-4">
            {[...Array(testimonial.rating)].map((_, i) => (
              <Star key={i} className="w-5 h-5 fill-yellow-400 text-yellow-400" />
            ))}
          </div>

          {/* Highlight Badge */}
          <div className="inline-block bg-pink-50 px-3 py-1 rounded-full mb-4">
            <span className="text-[#FF6B9D] text-sm font-semibold">{testimonial.highlight}</span>
          </div>

          {/* Testimonial Text */}
          <p className="text-gray-700 leading-relaxed mb-6 italic">
            "{testimonial.text}"
          </p>

          {/* User Info */}
          <div className="flex items-center gap-3 pt-4 border-t border-gray-100">
            <img
              src={testimonial.image}
              alt={testimonial.name}
              className="w-12 h-12 rounded-full object-cover border-2 border-pink-200"
            />
            <div>
              <h4 className="font-bold text-gray-900">{testimonial.name}</h4>
              <p className="text-sm text-gray-600">{testimonial.role}</p>
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
};

export default Testimonials;
